"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createSvgIcon_1 = __importDefault(require("../createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M0 10.6667H10.6667V8.88889H0V10.6667ZM0 0V1.77778H16V0H0ZM0 6.22222H16V4.44444H0V6.22222Z" })), 'Notes');
//# sourceMappingURL=index.js.map